import {Toast} from 'vant'
import * as ajax from "@/api/common"
// import wx from 'weixin-js-sdk';

let wechat={}

wechat.getsignature = function (url,success_Fun,err_Fun) {
    ajax.get('/Publics/getWxSign',{input_url:url}).then(async res => {
        wx.config({
          debug: false,
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature,// 必填，签名，见附录1
          success:e=>{
            Toast({message: e.errMsg , duration: 1500})
          },
          fail:e=>{
          console.log(e)
            // Toast({message: e.errMsg , duration: 1500})
        },
          jsApiList: [
            'checkJsApi',
            'scanQRCode',
            'openLocation',
            // 商家转账「用户确认收款」（v3 提现需用户在微信内确认才到账）
            'requestMerchantTransfer'
          ]
        })
        //处理验证失败的信息
        wx.error(function (res) {
          console.log(res)
          // Toast({message: res.errMsg , duration: 1500})
        })
    }).catch(res=>{
    // Toast({message: res.msg , duration: 1500});
  })
}
wechat.scanQRCode = function (success_Fun,err_Fun) {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有, "barCode"
      success: res=>{
        success_Fun(res)
    },
      fail:error=>{
        err_Fun(error)
    }
    })
}

// 拉起「商家转账-用户确认收款」页面
//
// 依据：https://pay.weixin.qq.com/doc/v3/merchant/4012716430
// H5 必须通过 WeixinJSBridge.invoke 调用（wx.requestMerchantTransfer 只在
// 小程序内可用），且需先 wx.config 并将 requestMerchantTransfer 加入 jsApiList。
//
// payload: { mchId, appId, package }
//   —— 三个值都必须与「发起转账」时传入的一致，否则微信会报参数错误
// success_Fun(ok)  确认页已展示并正常返回（**不代表已到账**，到账以服务端回调为准）
// cancel_Fun()     用户取消
// err_Fun(msg)     调起失败
wechat.requestMerchantTransfer = function (payload, success_Fun, cancel_Fun, err_Fun) {
  function doInvoke () {
    const bridge = window.WeixinJSBridge
    if (!bridge || !bridge.invoke) {
      err_Fun('请在微信中打开本页面')
      return
    }
    bridge.invoke('requestMerchantTransfer', {
      mchId: payload.mchId,
      appId: payload.appId,
      package: payload.package
    }, function (res) {
      const msg = (res && res.err_msg) || ''
      if (msg === 'requestMerchantTransfer:ok') {
        success_Fun(res)
      } else if (msg === 'requestMerchantTransfer:cancel') {
        cancel_Fun()
      } else {
        err_Fun(msg || '调起失败')
      }
    })
  }

  // 能力检测：不支持时给出明确提示，避免用户点了没反应
  function check () {
    if (typeof wx === 'undefined' || !wx.checkJsApi) {
      doInvoke()
      return
    }
    wx.checkJsApi({
      jsApiList: ['requestMerchantTransfer'],
      success: res => {
        if (res && res.checkResult && res.checkResult.requestMerchantTransfer === false) {
          err_Fun('你的微信版本过低，请升级微信后再试')
        } else {
          doInvoke()
        }
      },
      fail: () => doInvoke()
    })
  }

  if (typeof wx === 'undefined') {
    err_Fun('请在微信中打开本页面')
    return
  }
  // wx.ready 在 config 成功后触发；若已 ready 则立即回调
  wx.ready(check)
}

export default wechat;